module.exports = __webpack_public_path__ + "static/media/Successful_Search.273c7c13.png";